import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import styles from "./Portfolio.module.css";

const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    fetch("projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);
  return (
    <section id="projects">
      <div className="container">
        <div className="heading">
          <h2>Projects</h2>
          <span>Most recent Work</span>
        </div>
        <div className="row">
          {projects?.map((project) => (
            <div className="col-sm-6 col-md-3" key={project.id}>
              <div className={`card mb-3 ${styles.card}`}>
                <img
                  src={project.thumbnail}
                  className="w-100 max-h-100 img-cover"
                  alt="thumbnail"
                  style={{ height: "150px" }}
                />
                <div className="card-body">
                  <span>Web Design</span>
                  <h6 className={styles.sliderTitle}>
                    {project.title.substring(0, 50)}
                  </h6>
                  <p className="card-text">
                    {project.details.substring(0, 100)}...
                  </p>
                  <div className="mt-3 mb-5 mb-sm-0">
                    <Link
                      to={`/project/${project.id}`}
                      className={styles.cardBtn}
                    >
                      Details <FaArrowRight />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
